import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter, Inject,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {isUndefined} from 'util';
import {NotifierWrapService} from '../../../services/notifier-wrap.service';
import {ModalService} from '../../../services/modal.service';
import {from, Subject, Subscription, takeUntil} from 'rxjs';
import {filter} from 'rxjs/operators';
import {NzModalService} from 'ng-zorro-antd/modal';
import {VkService} from '../../../pages/page-vk/vk.service';
import {AllService} from '../../../services/all.service';
import {Router} from '@angular/router';
import {Chat, IMessengerConnector, Message, MessageUser} from '../../../types/all.type';
import {DatePipe} from '@angular/common';
import {InterfaceService} from '../../../services/interface.service';
import {CallService} from '../../../services/call.service';
import {AppService} from '../../../services/app.service';
import {DcService} from '../../../services/dc.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageComponent implements OnInit, AfterViewInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  detectChangesTimeout: NodeJS.Timeout;
  @Input() lvl = 0;
  @Input() messagesContainer: HTMLDivElement;
  @Input() type = 'self';
  @Input() out: boolean;

  @ViewChild('messageWrap') public messageWrap: ElementRef;

  @Input() isAvatar = false;
  @Input() index: number;
  @Input() message: Message;
  @Input() Service: IMessengerConnector;
  @Output() onEditMessage = new EventEmitter<any>();
  @Output() onToggleMessage = new EventEmitter<any>();
  @Output() onReplyMessage = new EventEmitter<any>();
  @Output() onOpenDetailInfo = new EventEmitter<any>();
  @Output() contextMenuOpen = new EventEmitter<any>();

  linkTgSubscribe: EventListenerOrEventListenerObject;

  constructor(
    private dcService: DcService,
    public appService: AppService,
    public interfaceService: InterfaceService,
    private datePipe: DatePipe,
    // private eventManager: EventManager,
    // private renderer: Renderer,
    public router: Router,
    private modal: NzModalService,
    public allService: AllService,
    private zone: NgZone,
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
    public notifierWrapService: NotifierWrapService,
    public modalService: ModalService,
    public callService: CallService
  ) {
  }

  ngOnInit(): void {
    // TODO
    if (this.Service instanceof VkService) {
      this.message.keyboard = [];
    }
    this.lvl++;

    if (this.message?.reply_to_messages?.length > 0) {
      this.message?.reply_to_messages.forEach((message: Message) => {
        const findMessage = this.Service.arHistory.find((v: Message) => v.id === message.id || v.date === message.date);
        if (findMessage) {
          message.compact = true;
          message.id = findMessage.id;
        }
      });
    }
    this.cd.detach();
    if (this.message?.from_user?.id) {
      this.message.color = this.appService.stringToHslColor(this.message.from_user.id);
    }
    if (this.message?.forward_from?.id) {
      this.message.forward_from.color = this.appService.stringToHslColor(this.message.forward_from.id);
    }
    this.cd.detectChanges();

    this.zone.runOutsideAngular(() => {
      this.dcService.detectChanges$.pipe(filter(
        (v => v === 'message' || v === 'message-' + this.message.id
        || v === 'message-animate-' + this.message.id)
      ), takeUntil(this.destroy$)).subscribe((event) => {
        if (event === 'message' || event === 'message-' + this.message.id) {
          this.detectChanges();
        }
        if (event === 'message-animate-' + this.message.id) {
          setTimeout(() => {
            this.message.effect = true;
            this.cd.detectChanges();
          }, 1000);
          setTimeout(() => {
            this.message.effect = false;
            this.cd.detectChanges();
          }, 2000);
        }
      });
    });
  }

  vizibleMessage(vizible, message) {
    if (vizible) {
      // this.Service.detectChanges$.next({type: 'message_vizible', id: message.id});
      this.Service.messageLastDate = message.date;
      if (!message?.out && message?.id > this.Service.openChat.read_inbox_max_id) {
        this.Service.openChat.read_inbox_max_id = message.id;
        from(this.allService.arChat)
          .pipe(filter((v: any) => v.last_message.id === message.id))
          .subscribe((chat: Chat) => {
            chat.unread_messages_count = 0;
            //// this.detectChanges();
          });
        /*this.Service.sendReadMaxId(this.Service.openChat.id, message.id).subscribe((result: any) => {

          },
          error => {
            this.interfaceService.errorHandling(error);
          });
         */
      }
    }
  }

  onClick(event) {
    let el = event.target || event.srcElement;
    if (!(el instanceof HTMLAnchorElement)) {
      el = event?.path?.find((v) => v.href?.length > 0);
    }
    if (el instanceof HTMLAnchorElement) {
      const href: string = el.getAttribute('href');
      if (href && this.Service.type === 'telegram') {
        if (href.includes('tg://user?id=')) {
          const id = href.replace('tg://user?id=', '').replace('unsafe:', '');
          // href = this.domSanitizer.bypassSecurityTrustResourceUrl(href);

          this.modalService.openModal('ModalChatDetailComponent', {
            Service: this.Service,
            id,
            type: 'user'
          });
          event.preventDefault();
        }
        /// Chats
        let url: URL | false = false;
        try {
          url = new URL(href);
        } catch (e) {
        }
        if (url && url.host === 't.me' && url.pathname.split('/').length === 2) {
          event.preventDefault();
          this.modalService.openModal('ModalChatDetailComponent', {
            Service: this.Service,
            id: url.pathname.replace('/', ''),
            type: 'user'
          });
          // this.router.navigate([`/telegram/chat/${parts[3]}`]);
        }
      }
    }
  }

  ngAfterViewInit() {
    // TODO приколхозил...
    // href="tg://user?id=1044952027"
    // https://t.me/pyrogramchat/51110
  }

  openDetailInfo(id, message: MessageUser | Chat) {
    this.modalService.openModal('ModalChatDetailComponent', {
      Service: this.Service,
      id,
      type: 'user',
      initData: message
    });
  }

  clickKeyBoard(button) {
    if (button.callback_data) {
      if (button.callback_data[0] === '/') {
        const arMessage: any = {
          chat_id: this.Service.openChatId,
          text: button.callback_data,
          attachments: {}
        };
        this.Service.sendMessage(arMessage).subscribe((result) => {
          result.forEach((message: Message) => {
            message.show = true;
            message.service_class = this.Service.type;
            this.allService.newMessage$.next(message);
          });
        });
        return;
      }
      this.Service.sendKeyBoard({
        chat_id: this.Service.openChatId,
        message_id: this.message.id,
        callback_data: button.callback_data
      }).subscribe(
        (result: any) => {
          this.notifierWrapService.notify('info', result.message);
        },
        (error) => {
          this.interfaceService.errorHandling(error);
        }
      );
    }
  }

  get runChangeDetection() {
    this.allService.arDetectChangesLog.MessageComponent++;
    return '';
  }

  toggleMessage($event: any, force = false) {
    this.message.force_select = force;
    this.onToggleMessage.emit(this.message);
    this.cd.detectChanges();
    // force && $event.preventDefault();
  }

  detectChanges() {
    clearTimeout(this.detectChangesTimeout);
    this.detectChangesTimeout = setTimeout(() => {
      this.cd.detectChanges();
    }, 80);
  }

  showDeleteMessage(): void {
    this.message.deleted = true;
    this.message.delete = false;
    this.message.empty = false;
    this.cd.detectChanges();
  }

  getCountSmile(str): number {
    if (!str || str?.length > 10) { return 0; }
    return [...str].filter((char) => str.charCodeAt(char) > 9985)?.length;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
